import MessagePage from './MessagePage';

export function LoadPage(): JSX.Element {
  return <MessagePage message="Loading ..." />;
}

export default LoadPage;
